import React from 'react';
import {
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { ITaskLog } from '../Interfaces/ITask';
import { castWithZeroTimezone } from '../core/generic_helper';

interface IProps {
  logArray: ITaskLog[];
  isLoading?: boolean;
}

/** Aufgaben-Log (#1248): read-only Verlauf, neueste Einträge zuerst. */
export const TaskLogList: React.FC<IProps> = ({
  logArray,
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (logArray.length === 0) {
    return (
      <Typography variant='body2' color='text.secondary' sx={{ my: 2 }}>
        Noch keine Log-Einträge
      </Typography>
    );
  }

  const sortedLog = [...logArray].sort(
    (a, b) =>
      new Date(String(b.Created_at)).getTime() -
      new Date(String(a.Created_at)).getTime()
  );

  return (
    <List dense sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
      {sortedLog.map(entry => (
        <ListItem key={`task-log-${entry.idTaskLog}`} divider>
          <ListItemText
            primary={entry.LogText}
            secondary={
              entry.Created_at
                ? castWithZeroTimezone(
                    String(entry.Created_at)
                  ).toLocaleString()
                : undefined
            }
          />
        </ListItem>
      ))}
    </List>
  );
};
